module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_circle.da9d5398.svg";